// Ported verbatim from nenda-autoplayer's src/lib/hooks/useTimedPlayback.ts.
// Zero React Native imports upstream - a plain timer hook, portable as-is.
import { useEffect, useRef, useState } from "react";

export interface TimedPlaybackOptions {
  duration: number;
  onCompleted: () => void;
}

export const useTimedPlayback = ({
  duration,
  onCompleted,
}: TimedPlaybackOptions) => {
  // This counter is used to restart even if the src remains the same,
  // for example if a playlist only contains one asset.
  const [restartCounter, setRestartCounter] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(duration);

  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const intervalRef = useRef<ReturnType<typeof setInterval> | undefined>(
    undefined
  );

  useEffect(() => {
    setRemainingSeconds(duration);

    intervalRef.current = setInterval(() => {
      setRemainingSeconds((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);

    timerRef.current = setTimeout(() => {
      setRestartCounter((prev) => prev + 1);
      onCompleted();
    }, duration * 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration, restartCounter]);

  return { remainingSeconds };
};
